import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';


@Component({
  selector: 'app-common-component',
  templateUrl: './common-component.component.html',
  styleUrls: ['./common-component.component.scss']
})
export class CommonComponentComponent implements OnInit {

  
  @ViewChild('changeGroupModal',{static:false}) public changeGroupModal: ModalDirective;
  @Output() someEvent = new EventEmitter<any>();
  @Output() saveEvent = new EventEmitter<any>();


  
  @Input() teamGroups = []; 
  @Input() selectedCategory = {}; 
  @Input() groupsNames = []; 
  @Input() isGenerateTiming=false
  selectedGroupIndex?
  selectedTeamIndex?


  constructor() {}

  ngOnInit(): void {
  }

  generateTiming(): void {
    console.log('this.teamGroups',this.teamGroups);
    this.someEvent.next({updatedTeams:this.teamGroups});

  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('chnages',changes);
    if(changes.selectedCategory){

    }
    // changes.prop contains the old and the new value...
  }



  confirmChangeGroup=()=>{
    this.changeGroupModal.hide();
  }

  changeTeamGroup(currentGroupIndex, currentTeamIndex,newGroupIndex){

    const tempTeams=this.teamGroups[currentGroupIndex].teams
    const selectedTeam=tempTeams[currentTeamIndex]
    tempTeams.splice(currentTeamIndex, 1);  
    const newTeams=this.teamGroups[newGroupIndex].teams
    newTeams.push(selectedTeam)
  }

  saveChanges=()=>{
    this.saveEvent.next({updatedTeams:this.teamGroups})
  }
}

